export enum TipoPagamentoAtendimento {
    Particular,
    Convenio
  }
